import { Injectable } from '@angular/core'
import { environment } from '../../../../../environments/environment'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import { ResponseRequestModel } from '../../../models/response.model'
import {
  CreatePaymentMethodsModel,
  DeletePaymentMethodsModel,
  EditPaymentMethodsModel,
  SearchPaymentMethodsModel,
} from '../../../models/payment-methods.model'

@Injectable({
  providedIn: 'root',
})
export class PaymentMethodsService {
  private baseUrl = environment.baseUrl
  private resource: string = 'FormaPagamento'

  constructor(private httpClient: HttpClient) {}

  public createPaymentMethods(
    model: CreatePaymentMethodsModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/create`,
      model,
    )
  }

  public editPaymentMethods(
    model: EditPaymentMethodsModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/edit`,
      model,
    )
  }

  public deletePaymentMethod(
    model: any,
    // model: DeletePaymentMethodsModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/delete`,
      model,
    )
  }

  public removePaymentMethod(
    model: any,
    // model: DeletePaymentMethodsModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/remove/${model.id}`,
      model,
    )
  }

  public listPagedPaymentMethods(
    page: number,
    rows: number = 15,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/listpaginated?pageNumber=${page}&pageSize=${rows}`,
    )
  }

  public listPagedPaymentMethodsByPerson(
    idPerson: number,
    page: number,
    rows: number = 15,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/listpaginated/pessoa/${idPerson}?pageNumber=${page}&pageSize=${rows}`,
    )
  }

  public listPaymentMethods(): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/listall`,
    )
  }

  public listPaymentMethodsByPerson(
    idPerson: number,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/list/pessoa/${idPerson}`,
    )
  }

  public searchPaymentMethods(
    model: SearchPaymentMethodsModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/search`,
      model,
    )
  }

  public getPaymentMethodsbyId(id: number): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/${id}`,
    )
  }

  public searchPagedPaymentMethods(
    page: number,
    rows: number = 15,
    model: SearchPaymentMethodsModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/search-paginated?pageNumber=${page}&pageSize=${rows}`,
      model,
    )
  }
}
